import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("linearGradient", {
  fill: "currentColor",
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: "100",
  y1: "617.327",
  x2: "100",
  y2: "757.05",
  gradientTransform: "translate(0 -567)"
}, [
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "0"
  }),
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "1"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M10 175.5c0 1.9.4 3.8 1.1 5.5.7 1.8 1.8 3.4 3.1 4.7s2.9 2.4 4.7 3.1c1.8.7 3.6 1.1 5.5 1.1h150.9c1.9 0 3.8-.4 5.5-1.1 1.8-.7 3.3-1.8 4.7-3.1 1.3-1.3 2.4-2.9 3.1-4.7.7-1.8 1.1-3.6 1.1-5.5V98.7c0-13.8-11.2-24.9-24.9-24.9H34.9C21.1 73.8 10 85 10 98.7v76.8zm122-75.6h12.8c.9 0 1.7.1 2.5.4.8.3 1.5.8 2.1 1.4.6.6 1.1 1.3 1.4 2.1.3.8.5 1.6.5 2.5s-.2 1.7-.5 2.5-.8 1.5-1.4 2.1c-.6.6-1.3 1.1-2.1 1.4-.8.3-1.7.5-2.5.4H132c-.9 0-1.7-.1-2.5-.4-.8-.3-1.5-.8-2.2-1.4-.6-.6-1.1-1.3-1.5-2.1-.3-.8-.5-1.7-.5-2.5 0-.9.2-1.7.5-2.5s.8-1.5 1.5-2.1c.6-.6 1.4-1.1 2.2-1.4.8-.2 1.6-.4 2.5-.4zm-38.5 0h12.8c.9 0 1.7.1 2.5.4s1.5.8 2.1 1.4c.6.6 1.1 1.3 1.4 2.1.3.8.5 1.6.5 2.5s-.2 1.7-.5 2.5-.8 1.5-1.4 2.1c-.6.6-1.3 1.1-2.1 1.4-.8.3-1.7.5-2.5.4H93.5c-.9 0-1.7-.1-2.5-.4-.8-.3-1.5-.8-2.2-1.4-.6-.6-1.1-1.3-1.5-2.1-.3-.8-.5-1.7-.5-2.5 0-.9.2-1.7.5-2.5s.8-1.5 1.5-2.1c.6-.6 1.4-1.1 2.2-1.4s1.6-.4 2.5-.4zm0 39.1h12.8c1.7 0 3.3.7 4.4 1.9 1.2 1.2 1.8 2.8 1.8 4.5s-.7 3.3-1.8 4.5-2.8 1.9-4.4 1.9H93.5c-1.7-.1-3.2-.8-4.4-2-1.1-1.2-1.8-2.8-1.8-4.5s.6-3.3 1.8-4.5c1.2-1 2.7-1.7 4.4-1.8zM54.9 99.9h12.8c.9 0 1.7.1 2.5.4.8.3 1.5.8 2.1 1.4.6.6 1.1 1.3 1.4 2.1.3.8.5 1.6.5 2.5s-.2 1.7-.5 2.5-.8 1.5-1.4 2.1c-.6.6-1.3 1.1-2.1 1.4-.8.3-1.7.5-2.5.4H54.9c-.9 0-1.7-.1-2.5-.4-.8-.3-1.5-.8-2.2-1.4-.6-.6-1.1-1.3-1.5-2.1-.3-.8-.5-1.7-.5-2.5 0-.9.2-1.7.5-2.5s.8-1.5 1.5-2.1c.6-.6 1.4-1.1 2.2-1.4.8-.2 1.6-.4 2.5-.4zm0 39.1h12.8c1.7 0 3.3.7 4.4 1.9 1.2 1.2 1.8 2.8 1.8 4.5s-.7 3.3-1.8 4.5c-1.2 1.2-2.8 1.9-4.4 1.9H54.9c-.9 0-1.7-.1-2.5-.4-.8-.3-1.5-.8-2.2-1.4-.6-.6-1.1-1.3-1.5-2.1-.3-.8-.5-1.7-.5-2.5s.2-1.7.5-2.5.8-1.5 1.5-2.1c.6-.6 1.4-1.1 2.2-1.4.8-.3 1.6-.4 2.5-.4zM189.8 37.3c0-1.9-.4-3.8-1.1-5.5-.7-1.8-1.8-3.4-3.1-4.7-1.3-1.3-2.9-2.4-4.7-3.1-1.8-.7-3.6-1.1-5.5-1.1h-24v-5.6c0-1.9-.8-3.8-2.1-5.1-1.4-1.4-3.2-2.1-5.1-2.1-1.9 0-3.8.8-5.1 2.1-1.4 1.4-2.1 3.2-2.1 5.1V23H63v-5.7c0-1.9-.8-3.8-2.1-5.1-1.4-1.4-3.2-2.1-5.1-2.1-1.9 0-3.8.8-5.1 2.1-1.4 1.4-2.1 3.2-2.1 5.1V23h-24c-3.8 0-7.5 1.5-10.2 4.2s-4.2 6.4-4.2 10.2v10.1c0 6.9 5.6 12.5 12.5 12.5h154.9c6.9 0 12.5-5.6 12.5-12.5V37.3h-.3z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
  ], 4))
}